document.addEventListener('DOMContentLoaded', function() {
  
  // 1. HERO SPOTLIGHT (Il bagliore segue il cursore su desktop)
  const hero = document.getElementById('koji-art-hero');
  if (hero && window.innerWidth > 990) {
    hero.addEventListener('mousemove', (e) => {
      const rect = hero.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      
      hero.style.setProperty('--mouse-x', `${x}px`);
      hero.style.setProperty('--mouse-y', `${y}px`);
    });
  }

  // 2. CARD 3D OLOGRAFICHE (Effetto tilt + riflesso luce)
  const cards = document.querySelectorAll('.koji-art-card-wrap');
  
  cards.forEach(wrap => {
    const card = wrap.querySelector('.koji-art-card');
    
    if (window.innerWidth > 990) {
      wrap.addEventListener('mousemove', (e) => {
        const rect = wrap.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        
        // Calcola rotazione 3D
        const centerX = rect.width / 2;
        const centerY = rect.height / 2;
        const rotateX = ((y - centerY) / centerY) * -15; // Max 15 gradi tilt
        const rotateY = ((x - centerX) / centerX) * 15;
        
        card.style.transform = `rotateX(${rotateX}deg) rotateY(${rotateY}deg)`;
        card.style.setProperty('--shine-x', `${x}px`);
        card.style.setProperty('--shine-y', `${y}px`);
      });

      wrap.addEventListener('mouseleave', () => {
        card.style.transform = `rotateX(0deg) rotateY(0deg)`;
      });
    }
  });

  // 3. SCROLL REVEAL (Entrata trionfale degli elementi)
  const observerOptions = { root: null, rootMargin: '0px', threshold: 0.15 };
  
  const scrollObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'translateY(0)';
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);

  // Applica stile iniziale e osserva le card e i testi
  const revealElements = document.querySelectorAll('.koji-art-card-wrap, .koji-art-mission-header, .koji-art-footer-title');
  revealElements.forEach((el, index) => {
    el.style.opacity = '0';
    el.style.transform = 'translateY(40px)';
    el.style.transition = `opacity 0.6s ease ${index * 0.1}s, transform 0.6s cubic-bezier(0.175, 0.885, 0.32, 1.275) ${index * 0.1}s`;
    scrollObserver.observe(el);
  });

});